import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
import {
  Button,
  Card,
  Col,
  ContentBody,
  ContentHeader,
  DatePicker,
  Row,
  ListItem,
  Select,
  Table
} from '../../../core/components'
import { Select as AntdSelect, Tabs } from 'antd'
import { dateTimeFormat } from '../../../utils/format/dateTimeFormat'
import { dateFormat } from '../../../utils/format/dateFormat'
import useOrderById from '../../../services/queries/order/useOrder'
import { formatCurrency } from '../../../utils/format/currencyFormat'
import { useMemo } from 'react'

const { TabPane } = Tabs
const { Option } = AntdSelect

export const DetailOrder = () => {
  const { goBack } = useHistory()
  const { id }: any = useParams()
  const { data: order, error, isLoading }: any = useOrderById(id)
  const OrderColumns = useMemo(
    () => [
      {
        title: 'Cód Produto',
        dataIndex: 'CD_MATERIAL'
      },
      {
        title: 'Descrição',
        dataIndex: 'DESCRICAO'
      },
      {
        title: 'Quantidade',
        dataIndex: 'QUANTIDADE'
      },
      {
        title: 'Preço original',
        dataIndex: 'PR_ORIGINAL',
        render: (value: any) => formatCurrency(value)
      },
      {
        title: 'Preço de Venda',
        dataIndex: 'PR_UNITARIO',
        render: (value: any) => formatCurrency(value)
      },
      {
        title: 'DESCONTO %',
        dataIndex: 'PE_DESCONTO',
        render: (value: any) => value
      },
      {
        title: 'TOTAL',
        dataIndex: 'TOTAL',
        render: (value: any, row: any) =>
          formatCurrency(row?.PR_UNITARIO * row?.QUANTIDADE || 0)
      }
    ],
    []
  )

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <div>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Detalhes do Pedido
      </ContentHeader>
      <ContentBody>
        <Tabs type="line">
          <TabPane tab="Geral" key="1">
            <Card>
              <div style={{ fontSize: '16px' }}>
                <Row>
                  <Col span={12}>
                    <ListItem label="N° Pedido">{order?.data?.id}</ListItem>
                    <ListItem label="CLIENTE">
                      {order?.data?.customer?.name}
                    </ListItem>
                    <ListItem label="VENDEDOR">
                      {order?.data?.salesman?.name}
                    </ListItem>
                    <ListItem label="UNID. NEGÓCIO">
                      {order?.data?.businessUnit?.name}
                    </ListItem>
                    <ListItem label="DATA DE ENTREGA">
                      {dateFormat(order?.data?.deliveryDate)}
                    </ListItem>
                    <ListItem label="DATA DO PEDIDO">
                      {dateFormat(order?.data?.orderDate)}
                    </ListItem>
                    <ListItem label="OBSERVAÇÃO">
                      {order?.data?.observation}
                    </ListItem>
                  </Col>
                  <Col span={12}>
                    <ListItem label="CONTROLE">
                      {order?.data?.status?.name}
                    </ListItem>
                    <ListItem label="CONDIÇÃO DE PAGAMENTO">
                      {order?.data?.paymentTerm?.description}
                    </ListItem>
                    <ListItem label="DESCONTO">
                      {formatCurrency(order?.data?.discount)}
                    </ListItem>
                    <ListItem label="ICMS">
                      {formatCurrency(order?.data?.discount)}
                    </ListItem>
                    <ListItem label="IPI">
                      {formatCurrency(order?.data?.discount)}
                    </ListItem>
                    <ListItem label="ST">
                      {formatCurrency(order?.data?.taxSubstitution)}
                    </ListItem>
                    <ListItem label="TOTAL DO PEDIDO">
                      {formatCurrency(order?.data?.total)}
                    </ListItem>
                  </Col>
                </Row>
              </div>
            </Card>
          </TabPane>
          <TabPane tab="Itens do pedido" key="2">
            <Table
              dataSource={order?.data?.items || []}
              columns={OrderColumns}
              bordered
              footer={() => (
                <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Col span={2}>
                    <span style={{ fontSize: 'bold' }}>{'Total:'}</span>
                  </Col>
                  <Col span={3}>
                    {formatCurrency(
                      order?.data?.items?.reduce(
                        (acc: any, cur: any) => acc + cur.PR_UNITARIO,
                        0
                      ) || 0
                    )}
                  </Col>
                </Row>
              )}
            />
          </TabPane>
        </Tabs>
      </ContentBody>
    </div>
  )
}
